
/**
 * A desk waiting for its next customer (the server's stand-by; Orchestra's
 * store-next). The clerk asks for it each time the hall empties — nothing turns it
 * on for a desk — because the one way it goes wrong is a customer called to a
 * window nobody is sitting at, and the clerk saying "I am here" is the only
 * defence. The call it waits for ends it, and so do Stop, a pause, closing the desk
 * and signing out.
 */

/** Offered only where Call next has nobody to give: a free, open desk with an
 *  empty line. The server calls somebody at once if the line was not really
 *  empty, so a screen a moment behind the hall loses nothing. */
export function offersStandBy(p: {
  occupied: boolean
  open: boolean
  standing: boolean
  waiting: number
}): boolean {
  return !p.occupied && p.open && !p.standing && p.waiting === 0
}

/** Whole seconds the desk has been waiting, or undefined when it is not. */
export function standingFor(
  desk: { standingBySince?: string } | undefined,
  now: number,
): number | undefined {
  if (!desk?.standingBySince) return undefined
  const since = Date.parse(desk.standingBySince)
  if (Number.isNaN(since)) return undefined
  return Math.max(0, Math.floor((now - since) / 1000))
}
